import React from "react";
import { Card } from "react-bootstrap";
import TauriImage from "../TauriImage/TauriImage";
import './OpalAccordionCardV6.css';

// FOR DISABLED/LOCKED ACCORDION
const OpalAccordionCardV6 = ({
    item,
    selectedCard,
    setSelectedCard,
    search
}) => {
    const highlightText = (text, query) => {
        if (!query) return text;

        const regex = new RegExp(`(${query})`, "gi");

        return text.split(regex).map((part, index) =>
            part.toLowerCase() === query.toLowerCase() ? (
                <span key={index} className="highlighted-text">
                    {part}
                </span>
            ) : (
                part
            )
        );
    };

    return (
        <Card key={item.ID} className="card-v6 mb-2">
            <div
                className={`custom-card card-body ${
                    selectedCard === item.ID ? "active-card" : ""
                } p-2`}
            >
                {/* Lock icon */}
                <TauriImage
                    localImage="/Images/mdi--users.svg"
                    className="lock-icon"
                    alt="Locked"
                    color={"#7A7A7A"}
                />

                <div className="d-flex align-items-center">
                    {/* Read-only counter */}
                    <div className="circle-counter flex-shrink-0 me-3 me-md-2 me-lg-3">
                        {item?.Dates?.length || 0}/
                        {item?.Customer?.Frequency_count || 0}
                    </div>

                    <Card.Title>
                        <div className="acc-code">
                            {highlightText(
                                item?.Code?.toUpperCase(),
                                search
                            )}
                        </div>

                        {highlightText(
                            item?.Name?.toUpperCase(),
                            search
                        )}
                    </Card.Title>
                </div>
            </div>
        </Card>
    );
};

export default OpalAccordionCardV6;
